import axios, { AxiosResponse } from 'axios';
import { UserUrl } from "./AUrl";
import { BodylessApiResponse } from "../interfaces";

/**
 * Checks if a user has a valid license.
 * @param token - The user's JWT token.
 * @returns A promise that resolves to a BodylessApiResponse indicating success or failure.
 */
export async function checkUserLicense(token: string): Promise<BodylessApiResponse> {
    const url = new UserUrl().checkLicense;
    let response: AxiosResponse<any>;

    try {
        response = await axios.post<string | null>(url, {}, {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            },
            // Resolve the promise for all HTTP status codes
            validateStatus: () => true
        });
    } catch (error) {
        return {
            status: 500,
            message: 'Network or other error occurred'
        };
    }

    if (response.status === 200) {
        return {
            status: response.status,
            message: "User has a valid license"
        };
    } else if (response.status === 404) {
        return {
            status: response.status,
            message: "User does not have any assigned license"
        };
    } else {
        return {
            status: response.status,
            message: response.data as string || "Unknown error"
        };
    }
}
